module.exports = __webpack_public_path__ + "media/images/ir/message/p_noutomi-0b1667553870f2cd4c251fecc4b220a1.png";